import '../sass/app.scss'
import $ from "jquery";
// import "slick-carousel";
import "fancybox";
// import "swiper";
// core version + navigation, pagination modules:



let accordion = document.querySelector('.accordion');
let items = accordion.querySelectorAll('.accordion__item');
let title = accordion.querySelectorAll('.accordion__title');

function toggleAccordion() {
  let thisItem = this.parentNode;
  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('active');
      return;
    }
    item.classList.remove('active');
  });
}

title.forEach(question => question.addEventListener('click', toggleAccordion));
window.$ = window.jQuery = jQuery;


$(function () {
  $('.menu__btn').on('click', function () {
    $('.menu__slide').toggleClass('menu__slide--active');
  });
});

// $(function () {
//   $('.slider').slick({
//     arrows: true,
//     dots: false,
//     slidesToShow: 5,
//     slidesToScroll: 5,
//     touchMove: true,
//     infinite: true,
//     responsive: [
//       {
//         breakpoint: 980,
//         settings: {
//           slidesToShow: 4,
//           slidesToScroll: 4,
//         }
//       },
//       {
//         breakpoint: 560,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3
//         }
//       }

//     ]
//   });

//   $('.replies__slider').slick({
//     dots: false,
//     arrows: true,
//     slidesToShow: 4,
//     adaptiveHeight: true,
//     touchMove: true,
//     infinite: true,
//     responsive: [
//       {
//         breakpoint: 1850,
//         settings: {
//           slidesToShow: 3,
//         }
//       },

//       {
//         breakpoint: 910,
//         settings:{
//         slidesToShow: 1
//       }
//       }
//     ]
//   });
// })

